module.exports = __webpack_public_path__ + "static/academic-683cb0da9343fc6d6ccf794c59e0f831.png";